import { apiClient } from 'api/apiClient';

const RESOURCE = '/addresses';

export interface IAddress {
	attention: string;
	addr: string;
	city: string;
	state: string;
	zip: string;
	phone1: string;
	phone2: string;
	contact: string;
	contactphone: string;
	fax: string;
	email: string;
	addressTypeEnum: string;
	addresstype: number;
	code: string;
	phonedesc1: string;
	phonedesc2: string;
	website: string;
	warehouse: boolean;
	shiptofromorder: boolean;
	sortname: string;
	parsetype: number;
	inactive: boolean;
	lastmodified: string;
	miscnotes: string;
	miscnotesrtf: string;
	typedesc: string;
	vendorisemployee: boolean;
	ccsiteid: string;
	cckey: string;
	ccname: string;
	emailcc: string;
	emailbcc: string;
	email2: string;
	ssmaTimeStamp: string;
	id: number;
}

export const getAddresses = async (filter?: string): Promise<IAddress[]> => {
	const { data } = await apiClient.get(`${RESOURCE}${filter ?? ''}`.trim(), {});
	return data;
};
